import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { axiosCentral, throwResponse } from "config/axios";
import {
  IDashboardParams,
  IResponseDashboardCentral,
} from "service/dashboard/interface";
import { IMenuRecord, IDashboardGraph } from "./interface";

export const postMenuRecord = async (data: IMenuRecord) => {
  const res = await axiosCentral.get("/menu-records");
  if (res.status === 200) {
    return res.data;
  }
  throwResponse(res);
  return res.data;
};

export const useGetDashboardWeb = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<number>[], Error> => {
  return useQuery(
    ["dashboard-property-web-record", params],
    async () => {
      const res = await axiosCentral.get("/dashboard/menu/records-web", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetDashboardAppTeamUp = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<number>[], Error> => {
  return useQuery(
    ["dashboard-property-app-team-up-record", params],
    async () => {
      const res = await axiosCentral.get(
        "/dashboard/menu/records-app-juristic",
        {
          params,
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetDashboardAppSmoothUp = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<number>[], Error> => {
  return useQuery(
    ["dashboard-property-app-smooth-up-record", params],
    async () => {
      const res = await axiosCentral.get(
        "/dashboard/menu/records-app-residents",
        {
          params,
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetDashboardAppSummary = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<number>[], Error> => {
  return useQuery(
    ["dashboard-property-summary-record", params],
    async () => {
      const res = await axiosCentral.get("/dashboard/menu/records-summary", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetDashboardGraph = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IDashboardGraph[]>[], Error> => {
  return useQuery(
    ["dashboard-property-graph-record", params],
    async () => {
      const res = await axiosCentral.get("/dashboard/menu/records-graph", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
